import { IIconProps } from "../types"

export default function IconUL4(props: IIconProps) {
  const width = props.size || props.width || (95 / 5) * 3
  const height = props.size || props.height || (112 / 5) * 3
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 95 112"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.6449 1.46898C55.7764 0.539276 51.6377 0.119411 47.3991 0.749209C43.1705 1.389 38.8518 3.07846 35.173 6.0775C31.4942 9.08654 28.4452 13.4052 25.4461 17.7138C22.4371 22.0324 19.4781 26.351 16.469 31.2594C13.47 36.1679 10.421 41.6661 8.1017 46.2346C5.77245 50.8032 4.16297 54.442 2.93336 57.7409C1.71375 61.0399 0.864024 63.9989 0.56412 66.838C0.274213 69.6671 0.524133 72.3762 1.41385 75.1753C2.30356 77.9645 3.82308 80.8435 6.53221 84.4424C9.24134 88.0312 13.1301 92.3498 17.9086 96.6685C22.697 100.977 28.3652 105.296 32.5139 107.965C36.6525 110.624 39.2817 111.644 43.6803 111.474C48.0789 111.304 54.2569 109.954 60.265 108.085C66.2731 106.225 72.1112 103.856 77.1896 100.307C82.2679 96.7484 86.5765 92.01 89.3257 88.1612C92.0848 84.3124 93.2644 81.3534 93.5643 74.7955C93.8542 68.2376 93.2644 58.0808 91.8649 47.8841C90.4753 37.6874 88.266 27.4506 85.6069 20.3429C82.9377 13.2352 79.8087 9.25648 75.4501 6.54735C71.0915 3.83822 65.5133 2.39868 60.6449 1.46898Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="0.899712"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
